module.exports = __webpack_public_path__ + "img/loading.5bf88551.svg";